import React, { Component } from 'react';
import Select from 'react-select';
import {HandleSubmit} from '../../func/HandleSubmit';
// import nl2br from 'react-newline-to-break';
import { BrowserRouter as Router, Route, Link, Redirect } from "react-router-dom";

class AddKala extends Component {
    constructor(props) {
        super(props);
        this.state = {
            Submit: '',
            RequestCode: 0,
            Products: 'none',
            SendParameters: {
                object: "kala",
                detail: {
                    kala_code: "",
                    kala_name: "",
                    // pressure: "",
                    // name: "",
                    // type_1: "",
                    // type_2: "",
                    // size: ""
                }
            },
            Validation: {},
            Loading: false,
            Header: {}
        };
        this.SetParameterValue = this.SetParameterValue.bind(this);
        this.GetHeaderOfTableOfInventory = this.GetHeaderOfTableOfInventory.bind(this);
        this.HandleSubmit = this.HandleSubmit.bind(this);
        this.CheckValidation = this.CheckValidation.bind(this);
        this.InitList = this.props.initlist.bind(this);
    }
    CheckValidation() {
        let ValidPass = true;
        let counter = 0;
        var ErrorMsg_Is_Blank = "IS BLANK";
        //Object.values(this.state.SendParameters.list(i => console.log(i)));
        Object.keys(this.state.SendParameters).forEach(element => {
            if (this.state.SendParameters[element] == "") {
                this.state.Validation = { ...this.state.Validation, [element]: ErrorMsg_Is_Blank };
            }
            else {
                this.state.Validation = { ...this.state.Validation, [element]: "" };
            }
        });
        if (ErrorMsg_Is_Blank !== "") {
            ValidPass = false;
        }
        this.setState(
            {
                Validation: this.state.Validation
            }
        );
        return ValidPass;
        //console.log(this.state.Validation);
    }
    async HandleSubmit() {
        this.setState({
            Loading: true,
            SendParameters: this.state.SendParameters
        });
        //////////////////////////////
        var response_info = await HandleSubmit('kala/add', this.state.SendParameters);
        //alert(response_info.status.request_code);
        if (response_info.status.trim() === "OK") {
            alert("ثبت گردید");
            this.InitList();
        }
        else {
            alert("مشکل در ثبت");
        }
        this.setState({
            Loading: false,
        });
    }
    SetParameterValue(name, value) {
        this.state.SendParameters.detail = { ...this.state.SendParameters.detail, [name]: value };
        this.setState({
            SendParameters: this.state.SendParameters,
        });
        console.log(this.state.SendParameters);
        // this.CheckValidation();
    }
    async GetHeaderOfTableOfInventory() {
        var response = await HandleSubmit('getdata/getheaderoftableofkala', '');
        this.state.Header.Name = JSON.parse(response).name,
            this.state.Header.Pressure = JSON.parse(response).pressure,
            this.state.Header.Type1 = JSON.parse(response).type_1,
            this.state.Header.Size = JSON.parse(response).size,
            this.state.Header.Type2 = JSON.parse(response).type_2,
            this.setState({
                Header: this.state.Header
            });
        console.log("header", this.state.Header);
    }
    async componentDidMount() {
        //   await this.GetHeaderOfTableOfInventory();
    }
    render() {
        //console.log(this.state.SendParameters.detail);
        if (this.state.Loading) { return "Loading..." }

        return (
            ShowForm(this.state.Header,
                this.state.SendParameters,
                this.state.Validation,
                this.SetParameterValue,
                this.HandleSubmit)
        );

    }
}
export default (AddKala);
const ShowForm = (items, defaultValue, Validation, funcSetParameterValue, funcHandleSubmit) => (
    <React.Fragment>
        <table className="table">
            <tbody><tr>
                <td>کد کالا</td>
                <td>
                    <input type="text"
                        className="form-control"
                        onChange={(e) => funcSetParameterValue("kala_code", e.target.value)}
                        //defaultvalue={defaultValue.kala_code}
                        value={defaultValue.kala_code}
                    />
                    <span>{Validation['kala_code']}</span>
                </td>
            </tr>
                <tr>
                    <td>نام</td>
                    <td>
                        <input type="text"
                            className="form-control"
                            onChange={(e) => funcSetParameterValue("kala_name", e.target.value)}
                            //defaultvalue={defaultValue.kala_code}
                            value={defaultValue.kala_code}
                        />
                        <span>{Validation['kala_name']}</span>
                    </td>
                    {/* <td>نام</td><td><Select
                    defaultValue={{ label: (defaultValue.name), value: defaultValue.name }}
                    onChange={(value) => (funcSetParameterValue("name", value.label))}
                    options={items.Name}
                />
                    <span>{Validation['name']}</span>
                </td>
                <td>فشار کاری</td><td><Select
                    onChange={(value) => (funcSetParameterValue("pressure", value.label))}
                    options={items.Pressure}
                />
                    <span>{Validation['pressure']}</span>
                </td>
                <td>نوع</td><td><Select
                    onChange={(value) => (funcSetParameterValue("type_1", value.label))}
                    options={items.Type1}
                />
                    <span>{Validation['type_1']}</span>
                </td>
                <td>سایز</td><td><Select
                    onChange={(value) => (funcSetParameterValue("size", value.label))}
                    options={items.Size}
                />
                    <span>{Validation['size']}</span>
                </td>
                <td>مشخصات</td><td><Select
                    onChange={(value) => (funcSetParameterValue("type_2", value.label))}
                    options={items.Type2} />
                    <span>{Validation['type_2']}</span>
                </td> */}

                </tr>
                <tr>
                    <td style={{ "textAlign": "right" }}>
                        <button className="btn btn-success" onClick={() => funcHandleSubmit()}>اضافه شود</button>
                    </td>
                </tr>
            </tbody></table>
    </React.Fragment>
);




// WEBPACK FOOTER //
// ./src/pages/Kala/AddKala.js